import { Link } from 'react-router-dom';
import { Icon, type IconName } from '@/components/ui/Icon';
import { company, nav } from '@/content/site';
import logoUrl from '@/assets/logo-full.png';
import styles from './Footer.module.css';

const socialIcon: Record<string, IconName> = {
  Facebook: 'facebook',
  Instagram: 'instagram',
  X: 'x',
};

// nav is a static module-level const with Services always present and
// populated — see src/content/site.ts. Non-null assertion is safe here.
const footerServiceLinks = nav.find((item) => item.label === 'Services')!.children!;

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={`${styles.footer} grain-overlay`}>
      <div className={styles.top}>
        <div className={styles.brand}>
          <Link to="/" className={styles.logoLink} aria-label="AniMon Infotech Solutions, home">
            <img src={logoUrl} alt="" className={styles.logo} width={2172} height={724} />
          </Link>
          <p className={styles.blurb}>{company.blurb}</p>
          <ul className={styles.social}>
            {company.social.map((s) => (
              <li key={s.label}>
                <a
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className={styles.socialLink}
                >
                  <Icon name={socialIcon[s.label] ?? 'arrowRight'} size={18} />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <nav className={styles.col} aria-label="Quick links">
          <h2 className={styles.heading}>Quick Links</h2>
          <ul className={styles.list}>
            <li>
              <Link to="/" className={styles.link}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className={styles.link}>
                About AniMon
              </Link>
            </li>
            <li>
              <Link to="/services" className={styles.link}>
                Services
              </Link>
            </li>
            <li>
              <Link to="/products" className={styles.link}>
                Products
              </Link>
            </li>
            <li>
              <Link to="/contact" className={styles.link}>
                Contact
              </Link>
            </li>
          </ul>
        </nav>

        <nav className={styles.col} aria-label="Our services">
          <h2 className={styles.heading}>Our Services</h2>
          <ul className={styles.list}>
            {footerServiceLinks.map((child) => (
              <li key={child.href}>
                <Link to={child.href} className={styles.link}>
                  {child.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.col}>
          <h2 className={styles.heading}>Contact Information</h2>
          <ul className={styles.list}>
            <li className={styles.contactItem}>
              <Icon name="mapPin" size={18} className={styles.contactIcon} />
              <span>{company.address.full}</span>
            </li>
            <li className={styles.contactItem}>
              <Icon name="mail" size={18} className={styles.contactIcon} />
              <a href={`mailto:${company.email}`} className={styles.link}>
                {company.email}
              </a>
            </li>
            {company.phones.map((phone) => (
              <li key={phone.href} className={styles.contactItem}>
                <Icon name="phone" size={18} className={styles.contactIcon} />
                <a href={phone.href} className={styles.link}>
                  {phone.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className={styles.bottom}>
        <p>
          Copyright &copy; {year} {company.name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
